import EmailLogin from "@/views/auth/EmailLogin.vue";
import EmailOtp from "@/views/auth/EmailOtp.vue";
import OperatorsOptions from "@/views/auth/OperatorsOptions.vue";
import OperatorsPlans from "@/views/auth/OperatorsPlans.vue";
import PhoneLogin from "@/views/auth/PhoneLogin.vue";
import PhoneOtp from "@/views/auth/PhoneOtp.vue";
import PlansOptions from "@/views/auth/PlansOptions.vue";
import ProfileStatus from "@/views/auth/ProfileStatus.vue";
import StripeView from "@/views/auth/StripeView.vue";
import SuccessOk from "@/views/auth/SuccessOk.vue";
import SuccessPage from "@/views/auth/SuccessPage.vue";
import MonthlyPlans from "@/views/auth/uae/MonthlyPlans.vue";
import CallBack from "@/views/response/CallBack.vue";
import BravoPay from "@/views/auth/uae/bravo/BravoPay.vue";
import BravoConfirm from "@/views/auth/uae/bravo/BravoConfirm.vue";
import WeeklyPlans from "@/views/auth/uae/WeeklyPlans.vue";
import OperatorsView from "@/views/OperatorsView.vue";
import SubscriptionsOptions from "@/views/auth/SubscriptionsOptions.vue";
import PackagesRedirect from "@/views/auth/PackagesRedirect.vue";
import PaymentCallback from "@/views/auth/PaymentCallback.vue";
import CancelSubs from "@/views/auth/CancelSubs.vue";
import FawrySuccess from "@/views/auth/FawrySuccess.vue";
import KsaSubscriptions from "@/views/auth/ksa/KsaSubscriptions.vue";
import SuccessPaymentPage  from "@/views/auth/payments/SuccessPaymentPage.vue";
import FailurePage from "@/views/auth/payments/FailurePage.vue";
import PendingPage from "@/views/auth/payments/PendingPage.vue";
export const authRoutesGlobal = [

    {
        path: '/auth/login',
        name: 'auth.login',
        component: PhoneLogin,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/login/email',
        name: 'auth.login.email',
        component: EmailLogin,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/operators/subscriptions',
        name: 'auth.operators',
        component: OperatorsOptions,
        meta: {
            footer: false,
            auth: false
        },
    },
     {
        path: '/operators/plans',
        name: 'auth.operators.plans',
        component: OperatorsView,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/fawry/success/:merchantRefNumber',
        name: 'fawry.success',
        component: FawrySuccess,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/operators/subscriptions/daily',
        name: 'auth.operators.daily',
        component: OperatorsPlans,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/operators/subscriptions/weekly',
        name: 'auth.operators.weekly',
        component: WeeklyPlans,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/operators/subscriptions/monthly',
        name: 'auth.operators.monthly',
        component: MonthlyPlans,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/subscriptions/options',
        name: 'auth.subscriptions',
        component: PlansOptions,
        meta: {
            footer: false,
            auth: true
        },
    },
    {
        path: '/auth/subscriptions/plans-options',
        name: 'auth.subscriptions.plans',
        component: SubscriptionsOptions,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/subscriptions/country-options/:country/:period',
        name: 'auth.subscriptions.plans.country.period',
        component: PackagesRedirect,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/subscriptions/bravo',
        name: 'bravo.pay',
        component: BravoPay,
        meta: {
            footer: false,
            auth: false
        },
    },
     {
        path: '/auth/subscriptions/bravo/confirm',
        name: 'bravo.confirm',
        component: BravoConfirm,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/subscriptions/stripe',
        name: 'auth.strip',
        component: StripeView,
        meta: {
            footer: false,
            auth: true
        },
    },
    {//auth/stripe/check-payment-intent
        path: '/auth/stripe/check-payment-intent',
        name: 'auth.stripe.payment',
        component: SuccessOk,
        meta: {
            footer: false,
            auth: false
        },
    },
     {
        path: '/auth/phone/check-otp',
        name: 'auth.otp.phone',
        component: PhoneOtp,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/email/check-otp',
        name: 'auth.otp.email',
        component: EmailOtp,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/success/page',
        name: 'otp.success.page',
        component: SuccessPage,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/:provider/callback',
        name: 'auth.provider.callback',
        component: CallBack,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/profile',
        name: 'auth.profile',
        component: ProfileStatus,
        meta: {
            footer: false,
            auth: true
        }
    },
    {
        path: '/auth/cancel-subs',
        name: 'auth.cancel-subs',
        component: CancelSubs,
        meta: {
            footer: false,
            auth: false
        }
    },
    {
        path: '/auth/ksa/subscriptions',
        name: 'auth.ksa.subscriptions',
        component: KsaSubscriptions,
        meta: {
            footer: false,
            auth: false
        },
    },
    {
        path: '/auth/payment/callback',
        name: 'auth.payment.callback',
        component: PaymentCallback,
        meta: {
            footer: false,
            auth: false
        }
    },
    {
        path: '/auth/:payment_gateway/success',
        name: 'auth.payment.success',
        component: SuccessPaymentPage,
        meta: {
            footer: false,
            auth: true
        }
    },
    {
        path: '/auth/:payment_gateway/pending',
        name: 'auth.payment.pending',
        component: PendingPage,
        meta: {
            footer: false,
            auth: true
        }
    },
    {
        path: '/auth/:payment_gateway/failure',
        name: 'auth.payment.failure',
        component: FailurePage,
        meta: {
            footer: false,
            auth: true
        }
    }




]


